<template>
  <div class="content full">
    <e-breadcrumbs />
    <win-layer-pop class="sample_popup_list">
      <component
        v-if="customComponent"
        :is="customComponent"
        @close="closePopup"
        :parent-info="parentInfo"
      />
    </win-layer-pop>
    <h1 class="page_title">{{ $t('cp.CTRL060P030.001') }}</h1>
    <div class="content_box mt10" id="frmReq">
      <table class="tbl_search">
        <colgroup>
          <col width="100px">
          <col>
          <col width="100px">
          <col>
          <col width="100px">
          <col>
          <col width="100px">
        </colgroup>
        <tbody>
          <tr>
            <th>{{ $t('cp.CTRL060P030.011') }}</th>
            <td colspan="5">
              <e-date-range-picker-for-settle
                :sdate="param.etdDtFr"
                :edate="param.etdDtTo"
                @change="changeDateRange"
              />
            </td>
          </tr>
          <tr>
            <th>{{ $t('cp.CTRL060P030.003') }}</th>
            <td>
              <div class="tbl_form cp-relative">
                <a href="#" @click.prevent="openPopup('CstSearchListPop', 'bkgShipper')" class="button sm cp-td-button">
                  <template v-if="param.bkgShipLength === 0 || param.bkgShipLength === undefined">
                    {{ $t('cp.COMMON.002') }}
                  </template>
                  <template v-else-if="param.bkgShipLength === 1">
                    <span class="cp-short-text">{{ param.lastBkgShip }}</span>
                  </template>
                  <template v-else>
                    <span class="cp-short-text">({{ param.bkgShipLength }}) {{ param.lastBkgShip }}</span>
                  </template>
                </a>
              </div>
            </td>
            <th>{{ $t('cp.CTRL060P030.006') }}</th>
            <td>
              <div class="tbl_form">
                <span class="dv">
                  <select v-model="param.porCtr" @change="getHarborList(param.porCtr)">
                    <option value="">{{ $t('cp.COMMON.002') }}</option>
                    <option v-for="(item, idx) in countryList" :key="idx" :value="item.ctrCd">{{ item.ctrEnm }}</option>
                  </select>
                </span>
                <span class="dv">
                  <select v-model="param.porPlc">
                    <option value="">{{ $t('cp.COMMON.002') }}</option>
                    <option v-for="(item, idx) in harborList" :key="idx" :value="item.plcCd">{{ item.plcNm }}</option>
                  </select>
                </span>
              </div>
            </td>
            <th>{{ $t('cp.CTRL060P030.007') }}</th>
            <td>
              <div class="tbl_form">
                <span class="dv">
                  <select v-model="param.dlyCtr" @change="getHarborList2(param.dlyCtr)">
                    <option value="">{{ $t('cp.COMMON.002') }}</option>
                    <option v-for="(item, idx) in countryList" :key="idx" :value="item.ctrCd">{{ item.ctrEnm }}</option>
                  </select>
                </span>
                <span class="dv">
                  <select v-model="param.dlyPlc">
                    <option value="">{{ $t('cp.COMMON.002') }}</option>
                    <option v-for="(item, idx) in harborList2" :key="idx" :value="item.plcCd">{{ item.plcNm }}</option>
                  </select>
                </span>
              </div>
            </td>
            <td class="text_right">
              <a class="button blue sh" href="#" @click.prevent="select">{{ $t('cp.COMMON.001') }}</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="content_box mt10">
      <div id="realgrid" class="mt5" style="width: 100%; height: 750px" />
    </div>
  </div>
</template>

  <script>
  import { createGrid } from '@/plugins/realgridUtil'
  import { rootComputed } from '@/store/helpers'
  import bsaPerformanceData from '@/api/rest/bsa/bsaPerformanceData'
  import bsaCommonInfo from '@/api/rest/bsa/bsaCommonInfo'
  import EBreadcrumbs from '@/components/common/EBreadcrumbs'
  import JSZip from 'jszip'

  window.JSZip = window.JSZip || JSZip
  let gridView = null
  let provider = null
  const fields = [
    { fieldName: 'bkgShprCstEnm', dataType: 'text' },
    { fieldName: 'actShprCstNo', dataType: 'text' },
    { fieldName: 'actShprCstEnm', dataType: 'text' },
    { fieldName: 'item', dataType: 'text' },
    { fieldName: 'porPlcCd', dataType: 'text' },
    { fieldName: 'dlyPlcCd', dataType: 'text' },
    { fieldName: 'fstRte', dataType: 'text' },
    { fieldName: 'vslCd', dataType: 'text' },
    { fieldName: 'voyNo', dataType: 'text' },
    { fieldName: 'etdDt', dataType: 'text' },
    { fieldName: 'etdDy', dataType: 'text' },
    { fieldName: 'closDt', dataType: 'text' },
    { fieldName: 'cgoClosDt', dataType: 'text' },
    { fieldName: 'porDlyTt', dataType: 'number' },
    { fieldName: 'polTrmlCd', dataType: 'text' },
    { fieldName: 'podTrmlCd', dataType: 'text' },
    { fieldName: 'bkgDt', dataType: 'text' },
    { fieldName: 'lstQtyAdjDt', dataType: 'text' },
    { fieldName: 'fstTeu', dataType: 'number' },
    { fieldName: 'amtAvg', dataType: 'number' },
    { fieldName: 'baseVol', dataType: 'text' },
    { fieldName: 'cm1', dataType: 'number' },
    { fieldName: 'grsWtTeu', dataType: 'number' },
    { fieldName: 'cntrTypCd', dataType: 'text' },
    { fieldName: 'twentyCnt', dataType: 'number' },
    { fieldName: 'hcCnt', dataType: 'number' },
    { fieldName: 'polPortCd', dataType: 'text' },
    { fieldName: 'podPortCd', dataType: 'text' },
    { fieldName: 'ts1', dataType: 'text' },
    { fieldName: 'ts2', dataType: 'text' },
    { fieldName: 'ts3', dataType: 'text' },
    { fieldName: 'route2', dataType: 'text' },
    { fieldName: 'route3', dataType: 'text' },
    { fieldName: 'route4', dataType: 'text' },
    { fieldName: 'schInqCnt', dataType: 'number' },
    { fieldName: 'cstPicNo', dataType: 'text' }
  ]
  const columns = [
    { name: 'bkgShprCstEnm', fieldName: 'bkgShprCstEnm', header: { text: app.$t('cp.CTRL060P030.003') }, editable: false, width: 200, styleName: 'text_left', renderer: { showTooltip: true }, footer: [{}, { styleName: 'text_left', numberFormat: '#,##0.###', suffix: ' 건', expression: 'count' }] },
    { name: 'actShprCstEnm', fieldName: 'actShprCstEnm', header: { text: app.$t('cp.CTRL060P030.004') }, editable: false, width: 200, styleName: 'text_left', renderer: { showTooltip: true }, footer: [{ text: '합계 : ' }, { text: '평균 : ' }] },
    { name: 'item', fieldName: 'item', header: { text: app.$t('cp.CTRL060P030.005') }, editable: false, width: 50 },
    { name: 'porPlcCd', fieldName: 'porPlcCd', header: { text: app.$t('cp.CTRL060P030.006') }, editable: false, width: 40 },
    { name: 'dlyPlcCd', fieldName: 'dlyPlcCd', header: { text: app.$t('cp.CTRL060P030.007') }, editable: false, width: 40 },
    { name: 'fstRte', fieldName: 'fstRte', header: { text: app.$t('cp.CTRL060P030.008') }, editable: false, width: 80 },
    { name: 'vslCd', fieldName: 'vslCd', header: { text: app.$t('cp.CTRL060P030.009') }, editable: false, width: 50 },
    { name: 'voyNo', fieldName: 'voyNo', header: { text: app.$t('cp.CTRL060P030.010') }, editable: false, width: 60 },
    { name: 'etdDt', fieldName: 'etdDt', header: { text: app.$t('cp.CTRL060P030.011') }, editable: false, width: 70 },
    { name: 'etdDy', fieldName: 'etdDy', header: { text: app.$t('cp.CTRL060P030.012') }, editable: false, width: 60 },
    { name: 'closDt', fieldName: 'closDt', header: { text: app.$t('cp.CTRL060P030.013') }, editable: false, width: 70 },
    { name: 'cgoClosDt', fieldName: 'cgoClosDt', header: { text: app.$t('cp.CTRL060P030.014') }, editable: false, width: 70 },
    { name: 'porDlyTt', fieldName: 'porDlyTt', type: 'data', header: { text: app.$t('cp.CTRL060P030.015') }, numberFormat: '#,##0.###', editable: false, width: 80, styleName: 'text_right', footer: [{ numberFormat: '#,##0.###', expression: 'sum' }, { numberFormat: '#,##0.###', expression: 'avg' }] },
    { name: 'polTrmlCd', fieldName: 'polTrmlCd', header: { text: app.$t('cp.CTRL060P030.016') }, editable: false, width: 80 },
    { name: 'podTrmlCd', fieldName: 'podTrmlCd', header: { text: app.$t('cp.CTRL060P030.017') }, editable: false, width: 80 },
    { name: 'bkgDt', fieldName: 'bkgDt', header: { text: app.$t('cp.CTRL060P030.018') }, editable: false, width: 70 },
    { name: 'lstQtyAdjDt', fieldName: 'lstQtyAdjDt', header: { text: app.$t('cp.CTRL060P030.019') }, editable: false, width: 70 },
    { name: 'fstTeu', fieldName: 'fstTeu', header: { text: app.$t('cp.CTRL060P030.020') }, numberFormat: '#,##0.###', editable: false, width: 80, styleName: 'text_right', footer: [{ numberFormat: '#,##0.###', expression: 'sum' }, { numberFormat: '#,##0.###', expression: 'avg' }] },
    { name: 'amtAvg', fieldName: 'amtAvg', header: { text: app.$t('cp.CTRL060P030.021') }, numberFormat: '#,##0.###', editable: false, width: 121, styleName: 'text_right', footer: [{ numberFormat: '#,##0.###', expression: 'sum' }, { numberFormat: '#,##0.###', expression: 'avg' }] },
    { name: 'baseVol', fieldName: 'baseVol', header: { text: app.$t('cp.CTRL060P030.022') }, editable: false, width: 60 },
    { name: 'cm1', fieldName: 'cm1', header: { text: app.$t('cp.CTRL060P030.023') }, numberFormat: '#,##0.###', editable: false, width: 60, styleName: 'text_right', footer: [{ numberFormat: '#,##0.###', expression: 'sum' }, { numberFormat: '#,##0.###', expression: 'avg' }] },
    { name: 'grsWtTeu', fieldName: 'grsWtTeu', header: { text: app.$t('cp.CTRL060P030.024') }, numberFormat: '#,##0.###', editable: false, styleName: 'text_right', width: 65, footer: [{ numberFormat: '#,##0.###', expression: 'sum' }, { numberFormat: '#,##0.###', expression: 'avg' }] },
    { name: 'cntrTypCd', fieldName: 'cntrTypCd', header: { text: app.$t('cp.CTRL060P030.025') }, editable: false, width: 60 },
    { name: 'twentyCnt', fieldName: 'twentyCnt', header: { text: app.$t('cp.CTRL060P030.026') }, numberFormat: '#,##0.###', editable: false, width: 60, styleName: 'text_right', footer: [{ numberFormat: '#,##0.###', expression: 'sum' }, { numberFormat: '#,##0.###', expression: 'avg' }] },
    { name: 'hcCnt', fieldName: 'hcCnt', header: { text: app.$t('cp.CTRL060P030.027') }, numberFormat: '#,##0.###', editable: false, width: 60, styleName: 'text_right', footer: [{ numberFormat: '#,##0.###', expression: 'sum' }, { numberFormat: '#,##0.###', expression: 'avg' }] },
    { name: 'polPortCd', fieldName: 'polPortCd', header: { text: app.$t('cp.CTRL060P030.028') }, editable: false, width: 50 },
    { name: 'podPortCd', fieldName: 'podPortCd', header: { text: app.$t('cp.CTRL060P030.029') }, editable: false, width: 50 },
    { name: 'ts1', fieldName: 'ts1', header: { text: app.$t('cp.CTRL060P030.030') }, editable: false, width: 50 },
    { name: 'ts2', fieldName: 'ts2', header: { text: app.$t('cp.CTRL060P030.031') }, editable: false, width: 50 },
    { name: 'ts3', fieldName: 'ts3', header: { text: app.$t('cp.CTRL060P030.032') }, editable: false, width: 50 },
    { name: 'route2', fieldName: 'route2', header: { text: app.$t('cp.CTRL060P030.033') }, editable: false, width: 50 },
    { name: 'route3', fieldName: 'route3', header: { text: app.$t('cp.CTRL060P030.034') }, editable: false, width: 50 },
    { name: 'route4', fieldName: 'route4', header: { text: app.$t('cp.CTRL060P030.035') }, editable: false, width: 50 },
    { name: 'schInqCnt', fieldName: 'schInqCnt', header: { text: app.$t('cp.CTRL060P030.036') }, numberFormat: '#,##0.###', editable: false, width: 115, styleName: 'text_right', footer: { numberFormat: '#,##0.###', expression: 'sum' } },
    { name: 'cstPicNo', fieldName: 'cstPicNo', header: { text: app.$t('cp.CTRL060P030.037') }, editable: false, width: 110, styleName: 'text_left', renderer: { showTooltip: true } }
  ]

  export default {
    name: 'BsaPerformanceDataList',
    components: {
      EBreadcrumbs,
      WinLayerPop: () => import('@/pages/trans/popup/WinLayerPop'),
      EDatePicker: () => import('@/components/common/EDatePicker'),
      EDateRangePickerForSettle: () => import('@/components/common/EDateRangePickerForSettle'),
      CstSearchListPop: () => import('@/pages/cp/popup/CstSearchListPop')
    },
    data: function () {
      return {
        customComponent: null,
        parentInfo: {
          position: '',
          ships: [],
          bkgShipper: []
        },
        list: [{}],
        param: {
          etdDtFr: '',
          etdDtTo: '',
          porCtr: '',
          porPlc: '',
          dlyCtr: '',
          dlyPlc: '',
          bkgShipper: '',
          bkgShipperList: [],
          bkgShipLength: 0,
          lastBkgShip: ''
        },
        countryList: [],
        countryList2: [],
        harborList: [],
        harborList2: []
        }
    },
    computed: {
      ...rootComputed
    },
    created () {
      const arrMonthInfo = this.$ekmtcCommon.getDefaultStEnDt({ startCode: 'M', startGap: 3, endCode: '', endGap: 0 })

      this.param.etdDtFr = arrMonthInfo.stDt
      this.param.etdDtTo = arrMonthInfo.enDt
    },
    mounted: function () {
      const $vm = this
      window.func = this
      const grid = createGrid('realgrid', {
        fields,
        columns,
        header: { heights: [45] },
        displayOptions: {
          rowHeight: 34,
          fitStyle: 'none',
          selectionStyle: 'rows'
        },
        footers: { visible: true, items: [{ height: 34 }, { height: 34 }] },
        options: { summaryMode: 'aggregate' },
        fixedOptions: { colCount: 5 },
        stateBar: {
          visible: false
        },
        checkBar: {
          visible: false
        },
        rowIndicator: {
          visible: false
        },
        sortingOptions: {
          style: 'inclusive',
          showSortOrder: true
        }
      })
      gridView = grid.gridView
      provider = grid.provider

      gridView.onShowTooltip = function (grid, idx, value) {
        const columns = ['bkgShprCstEnm', 'actShprCstEnm']
        if (columns.includes(idx.column)) {
          let breakLine = ''
          let oneLine = ''
          let oneLineByteLength = 0

          for (const token of value) {
            oneLine += token

            // 한글과 한글 외 텍스트의 너비 계산
            const unicode = token.charCodeAt(0)
            if (unicode > 127 || (unicode > 64 && unicode < 91)) {
              oneLineByteLength += 2
            } else {
              oneLineByteLength += 1
            }

            // 조건에 따른 개행
            if (token === '\n' || (token === ' ' && oneLineByteLength > 70)) {
              breakLine += oneLine + (token === '\n' ? '' : ' \n')
              oneLine = ''
              oneLineByteLength = 0
            }
          }
          breakLine += oneLine
          return breakLine
        }
      }

      $vm.getCountryList()
    },
    methods: {
      openAlert: function (msg) {
        let obj = {
          alertType: 'simple',
          onClose: this.closeFun,
          customCloseBtnClass: 'button blue lg simplert-test1',
          customCloseBtnText: this.$t('cp.COMMON.005'),
          useIcon: false,
          customClass: 'simple_alert',
          message: msg,
          type: 'info'
        }
        this.$ekmtcCommon.alert(obj)
      },
      getCountryList: function () {
        bsaCommonInfo.countryList().then(response => {
          this.countryList = response.data
          this.countryList2 = response.data
        }).catch(err => {
          console.log(err)
        })
      },
      getHarborList: function (val) {
        bsaCommonInfo.harborList(val).then(response => {
          this.harborList = response.data
          this.param.porPlc = ''
        }).catch(err => {
          console.log(err)
        })
      },
      getHarborList2: function (val) {
        bsaCommonInfo.harborList(val).then(response => {
          this.harborList2 = response.data
          this.param.dlyPlc = ''
        }).catch(err => {
          console.log(err)
        })
      },
      select: function () {
        bsaPerformanceData.list(this.param).then(response => {
          this.list = response.data
          if (this.list.length > 0) {
            provider.setRows(this.list)
            gridView.setCurrent({ itemIndex: 0 })
          } else {
            this.$ekmtcCommon.alertCallback(this.$t('cp.CTRL020G140.044'), () => {
              return false
            })
          }
        }).catch(err => {
          console.log(err)
        })
      },
      changeDateRange (s, d) {
        this.param.etdDtFr = s
        this.param.etdDtTo = d
      },
      // 'Booking Shipper' 자동완성 change event
      cstChange (vo) {
        this.pod = vo
        this.param.bkgShprCstEnm = vo.cdNm
        this.param.bkgShprCstNo = vo.cd
        const frm = document.querySelector('#frmReq')
        const elem = frm.querySelector('#bkgCst')
        this.$ekmtcCommon.hideErrorTooltip(elem)
      },
      readonlyItemchk: function ($e) {
        if (!this.isExistResult) {
          $e.target.checked = true
        }
      },
      convertFormatPeriod: function (periodFr, periodTo, defaultText) {
        if (this.isExistResult) {
          return `${periodFr.replace(/(\d{4})(\d{1,2}(?=\d{2})|\d{1,2}(?=\d{1}))(\d{1,2}).*/, '$1.$2.$3')} ~\n   ${periodTo.replace(/(\d{4})(\d{1,2}(?=\d{2})|\d{1,2}(?=\d{1}))(\d{1,2}).*/, '$1.$2.$3')}`
        } else {
          return defaultText
        }
      },
      convertFormatNum: function (num, type) {
        if (num === null || num === undefined || num === '') {
          return ''
        } else {
          const intAdjust = Number.isInteger(num) ? '.0' : ''
          const perSign = type === 'rate' ? ' %' : ''
          return num.toLocaleString() + intAdjust + perSign
        }
      },
      sortItemOrder: function (item) {
        if (this.isExistResult) {
          this.itemOrder.splice(this.itemOrder.indexOf(item), 1)
          this.itemOrder.push(item)
          const checkedList = this.itemOrder.filter((elem) => this.itemInfo[elem].checked === true)
          const uncheckedList = this.itemOrder.filter((elem) => this.itemInfo[elem].checked === false)
          this.itemOrder = [...checkedList, ...uncheckedList]

          const sortedLayout = ['bkgShprCstEnm', 'actShprCstEnm', 'por', 'dly', 'item']
          for (const item of this.itemOrder) {
            sortedLayout.push(layout2.slice(2).filter(obj => obj.name === item)[0])
          }
          gridView2.setColumnLayout(sortedLayout)

          for (const elem of Object.entries(this.itemInfo)) {
            const [item, info] = elem
            if (info.checked) {
              gridView2.layoutByName(item).visible = true
            } else {
              gridView2.layoutByName(item).visible = false
            }
          }

          if (checkedList.length !== 0) {
            gridView2.setVisible(true)
          } else {
            gridView2.setVisible(false)
          }
        }
      },
      async openPopup (compNm, position) {
        if (this.customComponent !== null) {
          this.customComponent = null
          this.$ekmtcCommon.layerClose()
        }

        this.parentInfo.position = position
        if (position === 'bkgShipper') {
          this.parentInfo.ships = this.param.bkgShipperList
        }

        this.customComponent = compNm
        this.position = position
        this.confirmChk = 'Y'
        this.$ekmtcCommon.layerOpen('.sample_popup_list')
      },
      closePopup (obj) {
        if (obj === undefined || obj === '' || obj === null) {
          this.customComponent = null
          this.$ekmtcCommon.layerClose('.sample_popup_list')
          return
        }

        switch (true) {
          case this.position === 'bkgShipper': {
            this.param.bkgShipper = obj.shipper.join(',')
            this.param.bkgShipperList = obj.shipper
            this.param.bkgShipLength = obj.shipLength
            this.param.lastBkgShip = obj.lastShip

            break
          }
        }

        this.customComponent = null
        this.$ekmtcCommon.layerClose('.sample_popup_list')
      },
      getExcelInfo: function () {
        this.excelInfo.bkgShprCstEnm = this.belowParam.bkgShprCstEnm
        this.excelInfo.actShprCstNo = this.belowParam.actShprCstNo
        this.excelInfo.actShprCstEnm = this.belowParam.actShprCstEnm
        this.excelInfo.item = this.belowParam.item
        this.excelInfo.por = this.belowParam.por
        this.excelInfo.dly = this.belowParam.dly
        this.excelInfo.fstRte = this.belowParam.fstRte
        this.excelInfo.vslCd = this.belowParam.vslCd
        this.excelInfo.voyNo = this.belowParam.voyNo
        this.excelInfo.etdDt = this.belowParam.etdDt
        this.excelInfo.etdDy = this.belowParam.etdDy
        this.excelInfo.closDt = this.belowParam.closDt
        this.excelInfo.cgoClosDt = this.belowParam.cgoClosDt
        this.excelInfo.transitTm = this.belowParam.transitTm
        this.excelInfo.porTml = this.belowParam.porTml
        this.excelInfo.dmlTml = this.belowParam.dmlTml
        this.excelInfo.bkgDt = this.belowParam.bkgDt
        this.excelInfo.lstTeuUpd = this.belowParam.lstTeuUpd
        this.excelInfo.fstTeu = this.belowParam.fstTeu
        this.excelInfo.amtAvg = this.belowParam.amtAvg
        this.excelInfo.baseVol = this.belowParam.baseVol
        this.excelInfo.cm1 = this.belowParam.cm1
        this.excelInfo.grsWtTeu = this.belowParam.grsWtTeu
        this.excelInfo.cntrTypCd = this.belowParam.cntrTypCd
        this.excelInfo.twentyCnt = this.belowParam.twentyCnt
        this.excelInfo.hcCnt = this.belowParam.hcCnt
        this.excelInfo.pol = this.belowParam.pol
        this.excelInfo.pod = this.belowParam.pod
        this.excelInfo.ts1 = this.belowParam.ts1
        this.excelInfo.ts2 = this.belowParam.ts2
        this.excelInfo.ts3 = this.belowParam.ts3
        this.excelInfo.route2 = this.belowParam.route2
        this.excelInfo.route3 = this.belowParam.route3
        this.excelInfo.route4 = this.belowParam.route4
        this.excelInfo.schInqCnt = this.belowParam.schInqCnt
        this.excelInfo.cstPicNo = this.belowParam.cstPicNo
      },
      exportExcel: function () {
        const checkedList = this.itemOrder.filter((elem) => this.itemInfo[elem].checked === true)
        if (checkedList.length === 0) {
          this.openAlert(this.$t('cp.CTRL020G140.049'))
          return
        }

        const date = new Date()
        const formatDate = date.getFullYear() + ('0' + (date.getMonth() + 1)).slice(-2) + ('0' + date.getDate()).slice(-2) + '_' + ('0' + date.getHours()).slice(-2) + ('0' + date.getMinutes()).slice(-2) + ('0' + date.getSeconds()).slice(-2)

        const title = this.excelInfo.scenarioNm
        const subTitle = `${this.excelInfo.selectFlagTxt} / [${this.$t('cp.CTRL020G140.015')}] ${this.excelInfo.periodDiv}: ${this.excelInfo.periodFrA}~${this.excelInfo.periodToA}, [${this.$t('cp.CTRL020G140.018')}] ${this.excelInfo.periodDiv}: ${this.excelInfo.periodFrB}~${this.excelInfo.periodToB}`
        const fileName = `${this.excelInfo.scenarioCd}_${this.excelInfo.scenarioNm}_${formatDate}.xlsx`
        const sheetName = `${this.excelInfo.optionFlagTxt}`

        if (this.excelInfo.optionFlag === 'E') {
          const excelData = []
          this.itemOrder.map((key) => {
            if (this.itemInfo[key].checked) {
              excelData.push(this.itemDataE[key])
            }
          })

          provider3.setRows(excelData)
          gridView3.exportGrid({
            type: 'excel',
            target: 'local',
            documentTitle: {
              message: title,
              visible: true,
              spaceTop: 0,
              spaceBottom: 0,
              height: 30,
              styleName: 'excelTitle'
            },
            documentSubtitle: {
              message: subTitle,
              spaceBottom: 1,
              visible: true,
              height: 20
            },
            fileName: fileName,
            showProgess: true,
            progressMessage: this.$t('cp.CTRL020G140.050'),
            indicator: 'hidden',
            applyFixed: false,
            header: 'visible',
            footer: 'hidden',
            pagingAllItems: true,
            separateRows: true,
            styleName: 'excelTitle',
            exportGrids: [
              { grid: gridView3, sheetName: sheetName }
            ]
          })
        } else if (this.excelInfo.optionFlag === 'I') {
          gridView2.exportGrid({
            type: 'excel',
            target: 'local',
            documentTitle: {
              message: title,
              visible: true,
              spaceTop: 0,
              spaceBottom: 0,
              height: 30,
              styleName: 'excelTitle'
            },
            documentSubtitle: {
              message: subTitle,
              spaceBottom: 1,
              visible: true,
              height: 20
            },
            fileName: fileName,
            showProgess: true,
            progressMessage: this.$t('cp.CTRL020G140.050'),
            indicator: 'hidden',
            applyFixed: false,
            header: 'visible',
            footer: 'hidden',
            pagingAllItems: true,
            separateRows: true,
            styleName: 'excelTitle',
            exportGrids: [
              { grid: gridView2, sheetName: sheetName }
            ]
          })
        }
        this.openAlert(this.$t('cp.CTRL020G140.051'))
      }
    }
  }
  </script>
  <style>
    /* sr : Scenario Result */
    .srtabmenu {
      table-layout: fixed;
    }

    .srtabmenu {
      border: 1px solid #e1e3eb !important;
    }

    .srtabmenu th {
      text-align: center;
    }

    .srtabmenu_itemchk td {
      text-align: center;
    }

    .srgraph_container {
      display: flex;
      padding: 10px;
      border: 1px solid #e1e3eb;
      gap: 10px;
    }

    .srgraph_content {
      width: 70%;
    }

    .srgraph_dashboard {
      display: flex;
      flex-wrap: wrap;
      height: inherit;
      gap: 10px;
    }

    .srgraph_unit {
      flex-basis: calc(33.33% - 6.7px);
      display: flex;
      height: 170px;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
    }

    .srgraph_unittitle {
      position: relative;
      width: 100%;
      height: 33px;
      border-top: 1px solid #e1e3eb;
      border-bottom: 1px solid #e1e3eb;
      background-color: #f6f9ff;
      color: #075bb9;
      font-size: 14px;
      font-weight: 500;
      text-align: center;
    }

    .srgraph_unitrow {
      display: grid;
      position: relative;
      width: 100%;
      height: 30px;
      box-sizing: border-box;
    }

    .srgraph_valA,
    .srgraph_valB {
      grid-template-columns: 2fr 1.5fr 6.5fr;
    }

    .srgraph_rate {
      grid-template-columns: 2fr 4fr 4fr;
    }

    .srgraph_leftbar {
      display: flex;
      position: relative;
      justify-content: flex-end;
      align-items: center;
      gap: 8px;
    }

    .srgraph_baseline {
      position: absolute;
      top: 0;
      right: 0;
      width: 1px;
      height: 27px;
      background-color: #e2e2e2;
    }

    .srgraph_basevalue {
      position: absolute;
      right: -11px;
      bottom: -17px;
      color: #777777;
      font-size: 12px;
    }

    .srgraph_rightbar {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 8px;
    }

    .srgraph_axistitle {
      font-size: 14px;
      line-height: 30px;
    }

    .srgraph_bar {
      width: 0px;
      height: 20px;
      opacity: 1;
      transition: width 0.5s ease-in, opacity 0.2s ease-out;
    }

    .srgraph_highlightbar {
      opacity: 0.7;
    }

    .srgraph_bar:hover {
      opacity: 0.7;
    }

    .srgraph_normalL {
      max-width: 20px;
    }
    .srgraph_normalR {
      max-width: 169px;
    }

    .srgraph_negative,
    .srgraph_positive {
      max-width: 67px;
    }

    .srgraph_normalL {
      background-color: #888888;
    }

    .srgraph_normalR {
      background-color: #888888;
    }

    .srgraph_negative {
      background-color: #0083df;
    }

    .srgraph_positive {
      background-color: #dc584e;
    }

    .srgraph_stats {
      width: 30%;
    }

    .srgraph_statshead,
    .srgraph_statsrow {
      display: grid;
      grid-template-columns: 1fr 1.1fr 1.1fr 0.8fr;
    }

    .srgraph_statshead {
      height: 66px;
      border-top: 1px solid #e1e3eb;
      border-bottom: 1px solid #e1e3eb;
      background: #f6f9ff;
      color: #075bb9;
      font-weight: 500;
      text-align: center;
    }

    .srgraph_statshead div:not(.srgraph_statshead div:first-child) {
      border-left: 1px solid #e1e3eb;
    }

    .srgraph_statsbody {
      display: flex;
      flex-wrap: wrap;
      height: calc(100% - 66px);
    }

    .srgraph_statsrow {
      text-align: center;
      flex-basis: 100%;
      border-bottom: 1px solid #e1e3eb;
    }

    .srgraph_statsvalue {
      display: flex;
      padding: 10px;
      border-left: 1px solid #e1e3eb;
      text-align: right;
      justify-content: flex-end;
      align-items: center;
    }

    .srgraph_statsname {
      padding-left: 5px;
      border-left: 0;
      background: #f6f9ff;
      color: #075bb9;
      font-weight: 500;
    }

    .srgraph_newline {
      white-space: pre;
    }

    .srgrid_hidden,
    .srgraph_hidden {
      display: none;
    }

    .srgraph_cleartag {
      visibility: hidden;
    }

    .srgraph_emptyvalue::after {
      content: '-';
    }

    .srgraph_centertext {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .excelTitle {
      font-size: 18px;
      font-weight: bold;
    }

    .cp-td-button {
    width: 100%;
    height: 24px !important;
    text-align: left;
    box-sizing: border-box;
    padding: 0 5px !important;
    color: #000000 !important;
    border: solid 1px #cecece !important;
    border-radius: 0px !important;
    background: url('data:image/png;base64,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') no-repeat center right;
  }

  .cp-td-button.disabled {
    border: 1px solid #e1e1e1 !important;
    color: #b7b7b7 !important;
    background: #f9f9f9 url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAFrGlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNS41LjAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIgogICAgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIgogICAgeG1sbnM6cGhvdG9zaG9wPSJodHRwOi8vbnMuYWRvYmUuY29tL3Bob3Rvc2hvcC8xLjAvIgogICAgeG1sbnM6ZGM9Imh0dHA6Ly9wdXJsLm9yZy9kYy9lbGVtZW50cy8xLjEvIgogICAgeG1sbnM6ZXhpZj0iaHR0cDovL25zLmFkb2JlLmNvbS9leGlmLzEuMC8iCiAgICB4bWxuczp0aWZmPSJodHRwOi8vbnMuYWRvYmUuY29tL3RpZmYvMS4wLyIKICAgIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIgogICAgeG1sbnM6c3RFdnQ9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZUV2ZW50IyIKICAgeG1wOkNyZWF0ZURhdGU9IjIwMjMtMDctMjBUMTY6NDM6NDErMDkwMCIKICAgeG1wOk1vZGlmeURhdGU9IjIwMjMtMDctMjdUMTM6NTE6MDkrMDk6MDAiCiAgIHhtcDpNZXRhZGF0YURhdGU9IjIwMjMtMDctMjdUMTM6NTE6MDkrMDk6MDAiCiAgIHBob3Rvc2hvcDpEYXRlQ3JlYXRlZD0iMjAyMy0wNy0yMFQxNjo0Mzo0MSswOTAwIgogICBwaG90b3Nob3A6Q29sb3JNb2RlPSIzIgogICBwaG90b3Nob3A6SUNDUHJvZmlsZT0ic1JHQiBJRUM2MTk2Ni0yLjEiCiAgIGV4aWY6UGl4ZWxYRGltZW5zaW9uPSIyNCIKICAgZXhpZjpQaXhlbFlEaW1lbnNpb249IjI0IgogICBleGlmOkNvbG9yU3BhY2U9IjEiCiAgIHRpZmY6SW1hZ2VXaWR0aD0iMjQiCiAgIHRpZmY6SW1hZ2VMZW5ndGg9IjI0IgogICB0aWZmOlJlc29sdXRpb25Vbml0PSIyIgogICB0aWZmOlhSZXNvbHV0aW9uPSI5Ni8xIgogICB0aWZmOllSZXNvbHV0aW9uPSI5Ni8xIj4KICAgPGRjOnRpdGxlPgogICAgPHJkZjpBbHQ+CiAgICAgPHJkZjpsaSB4bWw6bGFuZz0ieC1kZWZhdWx0Ij5sZW5zPC9yZGY6bGk+CiAgICA8L3JkZjpBbHQ+CiAgIDwvZGM6dGl0bGU+CiAgIDx4bXBNTTpIaXN0b3J5PgogICAgPHJkZjpTZXE+CiAgICAgPHJkZjpsaQogICAgICBzdEV2dDphY3Rpb249InByb2R1Y2VkIgogICAgICBzdEV2dDpzb2Z0d2FyZUFnZW50PSJBZmZpbml0eSBQaG90byAyIDIuMS4xIgogICAgICBzdEV2dDp3aGVuPSIyMDIzLTA3LTI3VDEzOjUxOjA5KzA5OjAwIi8+CiAgICA8L3JkZjpTZXE+CiAgIDwveG1wTU06SGlzdG9yeT4KICA8L3JkZjpEZXNjcmlwdGlvbj4KIDwvcmRmOlJERj4KPC94OnhtcG1ldGE+Cjw/eHBhY2tldCBlbmQ9InIiPz7D/hO5AAABgmlDQ1BzUkdCIElFQzYxOTY2LTIuMQAAKJF1kc8rRFEUxz8GjR+jUSwUi0lYzWiMmthYjBgKizHKYDPz5peaH6/3RpKtsp2ixMavBX8BW2WtFJGSLWtiw/ScNzM1k8y5nXs+93vvOd17LliCKSWtN7ghnclpAb/PsRhaclhfsdJNAy6aw4quzs5PBqlpXw/UmfHOZdaqfe5fa43GdAXqmoTHFFXLCU8Jz6znVJN3hTuVZDgqfC7s1OSCwvemHinxm8mJEv+YrAUD42BpF3YkqjhSxUpSSwvLy+lLp9aU8n3Ml9himYV5ib3iPegE8OPDwTQTjONliFGZvdIdD4Oyoka+u5g/R1ZyFZlVNtBYJUGSHE5R16R6TGJc9JiMFBtm///2VY8Pe0rVbT5ofDGMj36w7kAhbxjfx4ZROIH6Z7jKVPKzRzDyKXq+ovUdgn0LLq4rWmQPLreh60kNa+GiVC9uicfh/QzaQtBxCy3LpZ6V9zl9hOCmfNUN7B/AgJy3r/wCYPZn43Ablv4AAAAJcEhZcwAADsQAAA7EAZUrDhsAAAGnSURBVEiJ7dJPaxpBGAbwx65UV91lFyuaWBntoYKEHqQecjKHHvopck8+RL5B6C30Vuixp5LSj9CTC/YgkWRZWoXurH9GYdVxsorbSwsprIqmDT34HN9n3vkxMMAuuwDAcDh85ziOzxj7uOluaFXZ6XQ+WJb1cj6fxwCkAfQlSRrn8/nrbDb7+l4ApfSTaZovAIRkWb5VFGUihIi6risDACHkOyGkug4ILyssyzoAgEKhcJPL5V79nvd6vffNZrPabrcJ57wSi8Vqq4BHQUPbtu3FYpHRdX1893IASKVSx5lMpu/7Pul2u+frXhAITKfTPQBRTdOcoF5V1W8AIIRQtwIkSQIAeJ4XD+pns5n269xsK0DX9TMAbcdx0kE9pTQP4IemaVfrgKW/qNFoNAaDQSESiTiEkK/xePyzEOKo1Wodcs6fJBKJXrlcfr41AAD1ev16NBolAOz/sRQKoVQqvU0mkyf3AgCAUnrJGHvmed7jcDg8VxRlwBhL+76PYrH4RlXVi3V3bBzOecUwDLNWq5mu657+deDBEcMwvkwmk6f/BNnl/89PGGi3OyJin/0AAAAASUVORK5CYII=')  no-repeat center right;
  }

  .cp-td-button:active {
    border: 1px solid #003193 !important;
    color: #003193 !important;
  }

  .cp-td-button .cp-short-text {
    display: block;
    width: calc(100% - 16px);
    height: inherit;
    overflow: hidden;
    white-space: nowrap;
  }
  </style>
